let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8yDZu")).then(() => parcelRequire('dw7iu'));